export interface ViewportGaps {
  top: number;
  bottom: number;
}

/** Space between the viewport edges and an element, for placing viewport-fixed overlays over that element only. */
export function viewportGapsAround(rect: Pick<DOMRect, 'top' | 'bottom'>, viewportHeight: number): ViewportGaps {
  return {
    top: Math.max(0, Math.round(rect.top)),
    bottom: Math.max(0, Math.round(viewportHeight - rect.bottom)),
  };
}
